import { render, staticRenderFns } from "./creatTask.vue?vue&type=template&id=1f4dc183&scoped=true&"
import script from "./creatTask.vue?vue&type=script&lang=js&"
export * from "./creatTask.vue?vue&type=script&lang=js&"
import style0 from "./creatTask.vue?vue&type=style&index=0&id=1f4dc183&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4dc183",
  null
  
)

export default component.exports